// extracted by mini-css-extract-plugin
module.exports = {"tagText":"Tag_tagText__1BFYj","tagClose":"Tag_tagClose__3yfsU","tag":"Tag_tag__tyuht","buttonStyle":"Tag_buttonStyle__1OH-d"};